import React, { useEffect } from 'react';

function Footer() {
  useEffect(() => {
    const yearSpan = document.getElementById('current-year');
    if (yearSpan) {
      yearSpan.textContent = new Date().getFullYear().toString();
    }
  }, []);

  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          
          <div className="footer-logo-contact">
            <div className="footer-logo-container" style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
              <svg viewBox="0 0 24 24" style={{ height: '32px', color: 'var(--primary)' }} fill="none" stroke="currentColor" strokeWidth="2">
                <polygon points="12 2 2 7 12 12 22 7 12 2" />
                <polyline points="2 17 12 22 22 17" />
                <polyline points="2 12 12 17 22 12" />
              </svg>
              <span style={{ fontSize: '1.4rem', fontWeight: '800', fontFamily: 'Outfit', letterSpacing: '-0.03em', color: '#fff' }}>
                SAVAGE
              </span>
            </div>
            <div className="contact-info">
              <p><strong>Email:</strong> info@savage.today</p>
            </div>
          </div>

          <div className="footer-nav">
            <h4>Navigation</h4>
            <ul>
              <li><a href="#hero-section" className="smooth-scroll">Home</a></li>
              <li><a href="#services-section" className="smooth-scroll">Capabilities</a></li>
              <li><a href="#expertise-section" className="smooth-scroll">Stack</a></li>
              <li><a href="#why-choose-us-section" className="smooth-scroll">Why Savage</a></li>
              <li><a href="#process-section" className="smooth-scroll">Process</a></li>
              <li><a href="#contact-form" className="smooth-scroll">Contact</a></li>
            </ul>
          </div>

          <div className="footer-social">
            <h4>Connect With Us</h4>
            <div className="social-icons">
              {/* LinkedIn SVG */}
              <a href="https://www.linkedin.com/company/savage-technologies" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ height: '20px' }}>
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                  <rect x="2" y="9" width="4" height="12" />
                  <circle cx="4" cy="4" r="2" />
                </svg>
              </a>
              {/* Twitter/X SVG */}
              <a href="https://twitter.com/savage_tech" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ height: '20px' }}>
                  <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z" />
                </svg>
              </a>
            </div>
          </div>

        </div>
        <div className="footer-legal">
          <p>© <span id="current-year"></span> Savage Technologies. All rights reserved.</p>
          <p>
            <a href="#privacy" onClick={(e) => e.preventDefault()} title="Privacy Policy (Not yet available)">Privacy Policy</a> |{' '}
            <a href="#terms" onClick={(e) => e.preventDefault()} title="Terms of Service (Not yet available)">Terms of Service</a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
